module.exports = __webpack_public_path__ + "static/media/HeaderDropdown.b046e415.less";